module.exports = __webpack_public_path__ + "static/media/ncba.0664be83.png";